/**
 * Payload de previsualización o aprobación de una apertura: solo importes ARS; el backend obtiene
 * y conserva la cotización. Envía el físico y la cantidad sin valorizar revisados para detectar
 * cambios desde la revisión.
 * @param {Object} form Existencia revisada y datos de la apertura.
 * @returns {Object} Cuerpo para `material_costs/openings/preview` o `confirm`.
 */
export const materialOpeningPayload = (form) => ({
  uuid_article_stock: form.uuid,
  expected_quantity: form.quantity_on_hand,
  expected_updated_at: form.updated_at,
  expected_unvalued_quantity: form.unvalued_quantity,
  unit_cost_ars: Number(form.unit_cost_ars),
  source_notes: form.source_notes,
  evidence: { references: form.evidence },
});
